import React, { useEffect, useState } from "react";


import message from 'antd/lib/message';
import Spin from 'antd/lib/spin';
import { withRouter } from "react-router";
import AppService from '../../../../../service/app_service'

const PollResultPage = (props) => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(null);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [name, setName] = useState(null);
    const [showResult, setShowResult] = useState("xoxox");
    const [totalVotes, setTotalVotes] = useState(0);


    useEffect(() => {
        
        getTransactions(pageNumber);

    }, []);

    const getTransactions = async (pageNumber) => {
        setLoading(true);
        AppService.getEvotingDetail(pageSize, pageNumber, props.match.params.uid, showResult).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                setTransactions(rec.data);
            }
        })

    }



    const getPercentage = (option) => {
        let totalCount = 0;
        let count = 0;
        if(transactions && transactions.candidates && transactions.candidates.length > 0) {
          for (let i = 0; i < transactions.candidates.length; i++) {
            if (transactions.candidates[i].choice > 0) {
                if(transactions.candidates[i].choice == option) {
                    count++;
                }
                totalCount++;
            }
          }
          if(count === 0) {
              return 0;
          }
          let perc =  (count*100/totalCount).toFixed(0);
          // setTotalVotes(totalCount);
          return perc;
        }
        return 0;
    }


    const getNumberOfVotes = (option) => {
      let count = 0;
      if(transactions && transactions.candidates && transactions.candidates.length > 0) {
        for (let i = 0; i < transactions.candidates.length; i++) {
          if (transactions.candidates[i].choice > 0) {
              if(transactions.candidates[i].choice == option) {
                  count++;
              }
          }
        }
      }
      return count;
  }

    const getTotalVotes = () => {
        let totalCount = 0;
        for (let i = 0; i < transactions.candidates.length; i++) {
            if (transactions.candidates[i].choice > 0) {
                totalCount++;
            }
        }
        return totalCount;
    }


    return (
        <div>
            
        <Spin spinning={loading}>
        {transactions && <main className="thankyoupage" style={{display: 'block'}}>
          <div className="container">
            <div className="wrapper popreveal">
              <div className="main-heading">
              <h6 style={{marginBottom:'-40px'}}>VOTING RESULT</h6>
              <br/>
                {transactions && transactions.question}
              </div>
              <div className="pole-form">
                <div className="thankyou">
                {transactions && transactions.options && transactions.options.length > 0 && transactions.options.map((item, i) => {
                        return <div className="result opt1" key={i} style={{width: getPercentage(i+1)+'%'}} >
                            <div className="prnct">
                              {/* {getPercentage(i+1)}% */}
                            </div>
                            <div className="bar">
                                <label>{item.name}  ({getNumberOfVotes(i+1)} Votes)</label>
                                <div className="prnct-bar" style={{width: getPercentage(i+1)+'%'}}  />
                            </div>
                        </div>
                    })}
                  
                </div>
                <div className="next_prev">
                </div>
              </div>
              <footer>
                <div className="vote_count">
                  {<div className="total-votes">
                    Total Votes: {transactions && <span>{getTotalVotes()} / {transactions && transactions.candidates && transactions.candidates.length}</span>}
                  </div>}
                </div>
              </footer>
            </div>
          </div>
        </main>}
        </Spin>
        {/* thankyou section */}
        
        
      </div>
    );

}

export default withRouter(PollResultPage);
